export { default as StrategyComparisonDropdown } from './StrategyComparisonDropdown';